/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import litigationCaseTranslations from "./litigationCaseTranslations";
import { prosecutionTranslations } from "./prosecutionTranslations";
import addressTranslations from "./addressTranslations";

const abstractAdministrativeLitigationCaseTranslations = {
  ...litigationCaseTranslations,
  responsibleProsecution: prosecutionTranslations,
  employerType: {
    label: "Dienstherr",
    values: {
      federal: "Bund (Bundesbeamter)",
      state: "Land (Landesbeamter)",
      municipal: "Kommune / Stadt / Gemeinde",
    },
  },
  employerState: {
    label: "Dienstherr Bundesland",
    values: {
      BW: "Baden-Württemberg (BW)",
      BY: "Bayern (BY)",
      BE: "Berlin (BE)",
      BB: "Brandenburg (BB)",
      HB: "Bremen (HB)",
      HH: "Hamburg (HH)",
      HE: "Hessen (HE)",
      MV: "Mecklenburg-Vorpommern (MV)",
      NI: "Niedersachsen (NI)",
      NW: "Nordrhein-Westfalen (NW / NRW)",
      RP: "Rheinland-Pfalz (RP)",
      SL: "Saarland (SL)",
      SN: "Sachsen (SN)",
      ST: "Sachsen-Anhalt (ST)",
      SH: "Schleswig-Holstein (SH)",
      TH: "Thüringen (TH)",
    },
  },
  employerMunicipality: {
    label: "Dienstherr Kommune",
  },
  authorityName: {
    label: "Name der Dienststelle / Behörde",
  },
  authorityAddress: addressTranslations,
  authorityTelephone: {
    label: "Telefonnummer",
  },
  workLocationPostalCode: {
    label: "Dienstlicher Wohnsitz PLZ",
  },
  extrajudicialCommunicationSent: {
    label: "Widerspruch eingelegt am",
  },
  extrajudicialReaction: {
    label: "Reaktion der Gegenseite auf Widerspruch",
    enforceClaim: {
      label: "Reaktion der Gegenseite auf Widerspruch",
      values: {
        noReaction: "Keine Reaktion",
        fullyAgreed: "Forderung wird voll erfüllt",
        partiallyAgreed: "Forderung wird teilweise erfüllt",
        disagreed: "Forderung wird nicht erfüllt",
      },
    },
  },
  extrajudicialReactionReceived: {
    label: "Reaktion der Gegenseite auf Widerspruch am",
  },
  extrajudicialRecommendation: {
    label: "Empfehlung weiteres Vorgehen auf Reaktion der Gegenseite auf Widerspruch",
    values: {
      agreementDone: "Einigung erzielt / Forderung erledigt",
      lawsuit: "Klage einreichen / Klage abwarten",
      insufficientEvidence: "Schlechte Beweislage",
      insufficientChancesOfSuccess: "Schlechte Erfolgsaussicht",
      costBenefitConsiderations: "Schlechtes Kosten-Nutzen-Verhältnis",
      anonymousOpponent: "Gegenseite unklar",
      opponentUnableToPay: "Gegenseite nicht solvent",
      //failureToAct: "Untätigkeitsklage", // TODO: will be used later when failure to act is part of the automatic process
      individualText: "Individuelle Empfehlung",
    },
  },
  extrajudicialRecommendationText: {
    label: "Zusatztext Empfehlung weiteres Vorgehen auf Reaktion der Gegenseite auf Widerspruch",
  },
  administrativeDecisionRecommendation: {
    label: "Empfehlung weiteres Vorgehen Bescheid",
    values: {
      objection: "Widerspruch einlegen",
      accept: "Keinen Widerspruch einlegen",
      individualText: "Individuelle Empfehlung",
    },
  },
  administrativeDecisionRecommendationText: {
    label: "Zusatztext Empfehlung weiteres Vorgehen Bescheid",
  },
  administrativeDecisionReceivedDate: {
    label: "Bescheid erhalten am",
  },
  hasFiledObjectionToAdministrativeDecision: {
    label: "Wurde bereits Widerspruch eingelegt",
  },
  administrativeProceedingsLetterSentDate: {
    label: "Verwaltungsverfahren Schreiben am",
  },
  administrativeProceedingsLetterSentDeadline: {
    label: "Gesetzte Frist für Verwaltungsverfahren Gegenseite",
  },
  administrativeDecisionStatusClient: {
    label: "Stand Bescheid Mandantschaft",
    values: {
      fullyAgreed: "Anforderungen wurde voll entsprochen.",
      partiallyAgreed: "Anforderungen wurde nur teilweise entsprochen.",
      notAgreed: "Anforderungen wurde abgelehnt.",
      noReaction: "Keine Reaktion",
    },
  },
  administrativeDecisionFeedbackClient: {
    label: "Finale Entscheidung Mandantschaft Bescheid",
    values: {
      accept: "Bescheid akzeptieren / Vorgang beenden",
      objection: "Widerspruch einlegen",
    },
  },
  statementOfClaimSentDate: {
    ...litigationCaseTranslations.statementOfClaimSentDate,
    expeditedProceeding: {
      label: "Eilantrag gestellt am",
    },
    failureToActLawsuit: {
      ...litigationCaseTranslations.statementOfClaimSentDate,
    },
  },
  statementOfDefenseFiledDate: {
    ...litigationCaseTranslations.statementOfDefenseFiledDate,
    expeditedProceeding: {
      label: "Antragserwiderung erhalten am",
    },
    failureToActLawsuit: {
      ...litigationCaseTranslations.statementOfDefenseFiledDate,
    },
  },
  judgementReceivedDate: {
    ...litigationCaseTranslations.judgementReceivedDate,
    expeditedProceeding: {
      label: "Eingang Beschluss am",
    },
    failureToActLawsuit: {
      ...litigationCaseTranslations.judgementReceivedDate,
    },
  },
  lawsuitCompletedReason: {
    ...litigationCaseTranslations.lawsuitCompletedReason,
    expeditedProceeding: {
      ...litigationCaseTranslations.lawsuitCompletedReason,
      values: {
        ...litigationCaseTranslations.lawsuitCompletedReason.values,
        resolution: "Erledigungserklärung",
        lawsuitRevocation: "Antragsrücknahme",
      },
    },
    failureToActLawsuit: {
      ...litigationCaseTranslations.lawsuitCompletedReason,
    },
  },
  judgementEebSentDate: {
    ...litigationCaseTranslations.judgementEebSentDate,
    expeditedProceeding: {
      label: "EB-Datum Antrag",
    },
    failureToActLawsuit: {
      ...litigationCaseTranslations.judgementEebSentDate,
    },
  },
  promulgationOfJudgementDate: {
    ...litigationCaseTranslations.promulgationOfJudgementDate,
    expeditedProceeding: {
      label: "Verkündungsdatum des Antrags",
    },
    failureToActLawsuit: {
      ...litigationCaseTranslations.promulgationOfJudgementDate,
    },
  },
  extrajudicialCommunicationDeadline: {
    label: "Gesetzte Frist für Widerspruch Gegenseite",
  },
};

export default abstractAdministrativeLitigationCaseTranslations;
